import { useNavigate } from 'react-router-dom';
import { FunctionComponent, useEffect } from 'react';

export const ErrorElement: FunctionComponent<{
  redirectDelay: number;
  redirectTo: string;
}> = ({ redirectDelay, redirectTo }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const timeout = setTimeout(() => {
      navigate(redirectTo);
    }, redirectDelay);

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  return (
    <div className="sclc-fixed sclc-left-0 sclc-top-0 sclc-w-full sclc-h-full sclc-flex sclc-justify-center sclc-items-center sclc-bg-white sclc-opacity-100 sclc-z-50">
      <h1 className="sclc-text-5xl sclc-text-center sclc-text-slate-900 sclc-leading-normal">
        There has been an error. <br />
        Please call us on 0800 668 1552.
      </h1>
    </div>
  );
};
